import { Component } from '@angular/core';

const SIDEBAR_KEY = 'socrates.sidebar.collapsed';

@Component({
	selector: 'app-layout',
	templateUrl: './appLayout.component.html',
	standalone: false,
})
export class AppLayoutComponent {
	sidebarCollapsed = localStorage.getItem(SIDEBAR_KEY) === 'true';

	onSidebarCollapse(collapsed: boolean): void {
		this.sidebarCollapsed = collapsed;
		localStorage.setItem(SIDEBAR_KEY, String(collapsed));
	}
}
